import script from "./Monitor.vue?vue&type=script&setup=true&lang=js"
export * from "./Monitor.vue?vue&type=script&setup=true&lang=js"

import "./Monitor.vue?vue&type=style&index=0&id=5ff17acf&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff17acf"]])

export default __exports__